module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/td-ad4b4469031fb72bd98f795c031cfeee.svg";